import {
  Download1Stroke,
  Pencil1Stroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onEditClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onApproveClick?: () => void;
  onReviewProgressClick?: () => void;
  onReviewConfigClick?: () => void;
  onHideShowFilterClick?: () => void;
  className?: string;
}

export default function ActionBar({
  onEditClick,
  onRefreshClick,
  onFixedColumnsClick,
  onExportDataClick,
  onApproveClick,
  onReviewProgressClick,
  onReviewConfigClick,
  onHideShowFilterClick,
  className
}: ActionBarProps) {
  return (
    <>
      <ActionBarV2 className={className} title='Đơn từ bán hàng'>
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} />
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
        />

        <MenuButtonV2
          items={[
            {
              title: 'Duyệt nhiều đơn',
              icon: <AritoIcon icon={862} />,
              onClick: onApproveClick,
              group: 0
            },
            {
              title: 'Chuyển đổi người duyệt đang trong tiến trình duyệt',
              icon: <AritoIcon icon={377} />,
              onClick: onReviewProgressClick,
              group: 1
            },
            {
              title: 'Chuyển đổi người duyệt đã cấu hình',
              icon: <AritoIcon icon={382} />,
              onClick: onReviewConfigClick,
              group: 1
            },
            {
              title: 'Ẩn/hiển thị cây lọc tìm',
              icon: <AritoIcon icon={538} />,
              onClick: onHideShowFilterClick,
              group: 2
            }
          ]}
        />
      </ActionBarV2>
    </>
  );
}
